import React from 'react'
import { ComponenteBaseEnlace, ImagenEnlace, PrecioEnlace } from './ComponenteBase'

const DiseñoMinimal = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Configuración por defecto para el diseño Minimal
  const config = {
    mostrarIconos: true, // true | false
    mostrarDescripcion: false, // true | false
    alineacion: 'izquierda', // izquierda | centro
    espaciado: 'compacto', // compacto | normal
    ...configuracion
  }

  // Obtener clases de alineación
  const obtenerClasesAlineacion = () => {
    return config.alineacion === 'centro' ? 'text-center' : 'text-left'
  }

  // Obtener espaciado
  const obtenerEspaciado = () => {
    return config.espaciado === 'compacto' ? 'py-2' : 'py-3'
  }

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-1">
        {enlaces.map((enlace, index) => (
          <ComponenteBaseEnlace
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            className="enlace-miniatura"
          >
            <div className="py-1 hover:bg-gray-50 transition-colors duration-200 rounded">
              <div className={`space-y-1 ${obtenerClasesAlineacion()}`}>
                {/* Título arriba */}
                <h3 className="font-medium text-gray-800 hover:text-blue-600 transition-colors text-xs leading-tight truncate">
                  {enlace.titulo}
                </h3>
                
                {/* Imagen y precio */}
                {config.mostrarIconos && (
                  <div className="flex items-start gap-2">
                    <div className="flex-shrink-0">
                      <ImagenEnlace 
                        enlace={enlace} 
                        estilosMiniatura={estilosMiniatura}
                        mostrarIcono={false}
                      />
                    </div>
                    <div className="flex-1 flex flex-col gap-1">
                      {/* Precio para productos */}
                      {enlace.tipo === 'producto' && (
                        <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                      )}
                    </div>
                  </div>
                )}
                
                {/* Descripción abajo */}
                {config.mostrarDescripcion && enlace.descripcion && (
                  <p className="text-gray-500 text-xs leading-tight">
                    {enlace.descripcion}
                  </p>
                )}
                
                {/* Precio para enlaces que no son productos */}
                {enlace.tipo !== 'producto' && (
                  <div>
                    <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                  </div>
                )}
              </div>
            </div>
          </ComponenteBaseEnlace>
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-0">
      {enlaces.map((enlace, index) => (
        <ComponenteBaseEnlace
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          className="group"
        >
          <div className={`${obtenerEspaciado()} px-2 hover:bg-gray-50 transition-colors duration-200 rounded-lg border-b border-gray-100 last:border-b-0`}>
            <div className={`space-y-2 ${obtenerClasesAlineacion()}`}>
              {/* Título arriba */}
              <h3 className="font-medium text-gray-800 group-hover:text-blue-600 transition-colors text-base">
                {enlace.titulo}
              </h3>
              
              {/* Imagen y precio */}
              {config.mostrarIconos && (
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <ImagenEnlace 
                      enlace={enlace} 
                      estilosMiniatura={estilosMiniatura}
                      mostrarIcono={false}
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-2">
                    {/* Precio para productos */}
                    {enlace.tipo === 'producto' && (
                      <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                    )}
                  </div>
                </div>
              )}
              
              {/* Descripción abajo */}
              {config.mostrarDescripcion && enlace.descripcion && (
                <p className="text-gray-500 text-sm">
                  {enlace.descripcion}
                </p>
              )}
              
              {/* Precio para enlaces que no son productos */}
              {enlace.tipo !== 'producto' && (
                <div>
                  <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                </div>
              )}
            </div>
          </div>
        </ComponenteBaseEnlace>
      ))}
    </div>
  )
}

export default DiseñoMinimal 